import { h } from "snabbdom";
import type { VNode } from "snabbdom";
import type { LinkDialog, Msg } from "../types";

export function viewLinkDialog(dialog: LinkDialog, dispatch: (msg: Msg) => void): VNode {
  const setField = (key: "text" | "url") => (e: Event) =>
    dispatch({ type: "SetLinkField", key, value: (e.target as HTMLInputElement).value });

  return h(
    "div.vb-overlay",
    {
      on: {
        click: (e: Event) => {
          if ((e.target as HTMLElement).classList.contains("vb-overlay")) {
            dispatch({ type: "CloseLinkDialog" });
          }
        },
      },
    },
    [
      h("div.vb-dialog", [
        h("h3.vb-dialog__title", "Insert link"),
        h(
          "form.vb-dialog__form",
          {
            on: {
              submit: (e: Event) => {
                e.preventDefault();
                dispatch({ type: "CommitLink" });
              },
            },
          },
          [
            h("label.vb-label", [
              "URL",
              h("input.vb-input", {
                attrs: { name: "url", placeholder: "https://example.com", value: dialog.url },
                on: { input: setField("url") },
                hook: { insert: (vn) => (vn.elm as HTMLInputElement).focus() },
              }),
            ]),
            h("label.vb-label", [
              "Text",
              h("span.vb-hint", " (optional)"),
              h("input.vb-input", {
                attrs: { name: "text", placeholder: "Defaults to the URL", value: dialog.text },
                on: { input: setField("text") },
              }),
            ]),
            h("div.vb-dialog__actions", [
              h(
                "button.vb-btn.vb-btn--cancel",
                { attrs: { type: "button" }, on: { click: () => dispatch({ type: "CloseLinkDialog" }) } },
                "Cancel"
              ),
              h("button.vb-btn.vb-btn--insert", { attrs: { type: "submit" } }, "Insert"),
            ]),
          ]
        ),
      ]),
    ]
  );
}
